export const ORDERS = 'Заявки' as const
export const SALES = 'Продажи' as const
export const USERS = 'Пользователи' as const
export const SETTINGS = 'Настройки' as const
export const MENU = 'Меню' as const
export const DISHES = 'Блюда' as const
export const COMPLEXES = 'Комплекты' as const
export const CASHBOX = 'Касса' as const
export const SU = 'su' as const
